import { render } from "./RealTimeInfo.vue?vue&type=template&id=5bbf208f&scoped=true"
import script from "./RealTimeInfo.vue?vue&type=script&lang=js"
export * from "./RealTimeInfo.vue?vue&type=script&lang=js"

import "./RealTimeInfo.vue?vue&type=style&index=0&id=5bbf208f&lang=scss&scoped=true"

import exportComponent from "/Users/vee/Desktop/git/web/bitcoooPcWebsite/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bbf208f"]])

export default __exports__